import type { FC } from "react";

import { abbrNumberFilter, minVisitsFilter, percentageFilter } from "app/filters/ngFilters";

import type { ITableCellProps } from "../interfaces/ITableCellProps";

import { ProgressBarContainer } from "./ProgressBarContainer";

export const DemographicsShare: FC<ITableCellProps> = ({ value, row, progressBarTooltip }) => {
    const width = value ? value * 100 : 0,
        visits = row[progressBarTooltip]
            ? row[progressBarTooltip] < 5000
                ? minVisitsFilter()(row[progressBarTooltip])
                : abbrNumberFilter()(row[progressBarTooltip])
            : false,
        valuePercents = value ? percentageFilter()(value || 0, 2) + "%" : "N/A";

    return (
        <ProgressBarContainer
            progressBarWidth={width}
            visits={visits}
            valuePercents={valuePercents}
        />
    );
};
DemographicsShare.displayName = "DemographicsShare";
